import store from '../store'

export default async (to, from, next) => {

    if (to.query.token) {
        // Save the token.
        store.dispatch('auth/saveToken', {
            token: to.query.token,
        })
    }

    let greenGo = !!store.getters['auth/check']

    // Role check
    const user = store.getters['auth/user']
    let role = null
    let userCanCreateOrder = null
    if (user) {
        role = user.role ? user.role.name : null
    }

    if (to.meta.roles) greenGo = to.meta.roles.includes(role)
    if (to.meta.role) greenGo = to.meta.role == role

    if (user) {
        userCanCreateOrder = user.lending_point ? user.lending_point.enable_lending_creation === 1 : greenGo
    }

    let isLendingPoint = to.name === 'lending-point.order'

    if (isLendingPoint) {
        if (userCanCreateOrder) {
            greenGo = true
        } else {
            greenGo = false
        }
    }

    let enable2fa = false

    if (user)
        user.market.configurations.filter(config => {
            if (config.description == 'enable_2fa') enable2fa = !!(parseInt(config.pivot.value))
        })

    if (enable2fa) {
        if (!user.twoFaAuthenticated) {
            next({name: '2fa'})
        } else {
            store.dispatch('auth/refreshTwoFactorToken')
        }
    }

    // end role check
    if (user) {
        if (!greenGo) {
            next({name: 'home'})
        } else {
            next()
        }
    } else {
        next({name: 'login'})
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/auth.js